import { Directive, HostListener } from '@angular/core';

/**
 * A directive used on inputs, that prevents default when "Enter" key is pressed while that input is focused.
 * This was used because in some cases (probably due to form submission) when the user pressed enter in an input
 * Other inputs from the form would get resetted, even though it should not.
 * Example:
 * in a form with a typeahead component we select a supplier whose id we save in a FormGroup
 * we also had a <input type="time"> there and when the user pressed enter while this was focused
 * the previous selected supplier from the typeahead component would be cleared without a clear reason.
 */
@Directive({
    selector: '[appBlurOnEnter]',
})
export class BlurOnEnterDirective {
    @HostListener('keydown.enter', ['$event'])
    onEnter(event: Event) {
        event?.preventDefault();
        (event.target as HTMLElement)?.blur();
    }
}
